module.exports = __webpack_public_path__ + "static/media/fs5.d05e74c8.pdf";